"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneVerificationWithoutForm = void 0;
var PhoneVerificationWithoutForm_1 = require("./PhoneVerificationWithoutForm");
Object.defineProperty(exports, "PhoneVerificationWithoutForm", { enumerable: true, get: function () { return __importDefault(PhoneVerificationWithoutForm_1).default; } });
